import {baseApi} from '../../rest'
import {
  PublicHolidayListRequest,
  PublicHolidayPayload,
  MultipleSiteSuspendedPeriodPayload,
  MultipleSiteSuspendedPeriodResponse,
  PublicHolidaySuspendedPeriodPayload,
  PublicHolidaySuspendedPeriodResponse
} from './state'

export const multipleSiteSuspendedPeriodsApi = {
  ...baseApi,
  async newMultipleSiteSuspendedPeriod(payload: MultipleSiteSuspendedPeriodPayload) {
    const req = await this.doRequest<any>({
      path: `/v1/multipleSiteSuspendedPeriods/multipleSiteSuspendedPeriod`,
      payload
    })
    const resp = (await req.post()) as unknown
    return resp as MultipleSiteSuspendedPeriodResponse
  },
  async newPublicHolidaySuspendedPeriod(payload: PublicHolidaySuspendedPeriodPayload) {
    const req = await this.doRequest<any>({
      path: `/v1/multipleSiteSuspendedPeriods/publicHolidaySuspendedPeriods`,
      payload
    })
    const resp = (await req.post()) as unknown
    return resp as PublicHolidaySuspendedPeriodResponse
  },
  async getPublicHolidays({countryCode, year}: PublicHolidayListRequest) {
    const req = await this.doRequest<any>({
      path: `/v1/multipleSiteSuspendedPeriods/publicHolidays/${countryCode}/${year}`
    })
    const resp = (await req.get()) as unknown
    return resp as PublicHolidayPayload[]
  }
}
